export const PAGE_TITLES = {
  dashboard: 'Dashboard',
  'my-account': 'My Account',
  'create-ai-exam': 'Create AI Exam',
  'create-patient': 'Create Patient',
  'loading-predictions': 'AI Analysis',
  validation: 'Validate AI Analysis',
  'study-manager': 'Study Manager',
  patients: 'Patient List',
  about: 'About',
};
